import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
//imports
import { useNavigate } from "react-router-dom";
import ReactInputMask from "react-input-mask";
import { ThreeDots } from "react-loader-spinner";
//components
import { postDoc } from "../../services/Login/postDoc.js";
import { useAppContext } from "../../context/AppContext.jsx";
//images
import logo from "../../assets/logo.png";
import darkLogo from "../../assets/darkLogo.png";
import { statusAccount } from "../../utils/auth.js";

export default function SendDocument() {
  const navigate = useNavigate();

  const [foto, setFoto] = useState(logo);
  const [doc, setDoc] = useState("");
  const [allDocs, setAllDocs] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const [loading, setLoading] = useState(false);
  const [firstDoc, setFirstDoc] = useState(true);
  const [moreDocs, setMoreDocs] = useState(false);

  const [mask, setMask] = useState("999.999.999-999");

  const inputRef = useRef(null);

  const getDark = localStorage.getItem("appDarkMode");

  const {
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  } = useAppContext();

  useEffect(() => {
    if (getDark === "true") {
      setFoto(logo);
    } else {
      if (window.innerWidth <= 992) {
        setFoto(logo);
      } else {
        setFoto(darkLogo);
      }
    }
  }, [getDark]);
  useEffect(() => {
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");

    return () => {
      handleSetAppSidebarNone(false);
      handleSetAppHeaderNone(false);
      handleSetAppContentClass("");
    };
  }, [
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  ]);

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    let sendDoc = doc.replace(/\D/g, "");
    if (sendDoc.length === 11) {
      sendDoc = sendDoc.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        "$1.$2.$3-$4"
      );
    } else if (sendDoc.length === 14) {
      sendDoc = sendDoc.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
    } else {
      toast.warning("Oops algo deu errado, tente novamente.");
      setLoading(false);
      return;
    }

    try {
      const response = await postDoc(sendDoc);
// console.log(response);
      if (
        response[0].status_user === 0 ||
        response[0].status_environment === 0
      ) {
        setShowAlert(true);
        setLoading(false);
        return;
      }
      if (response[0].status_user === 1) {
        statusAccount(response[0].status_user);
      }
      if (response.length <= 1) {
        const id = response[0].id;
        const id_environment = response[0].environment_id;

        navigate(`/login/${id}`, {
          state: { doc: { sendDoc, id_environment } },
        });
      } else {
        setFirstDoc(false);
        setMoreDocs(true);
        setAllDocs(response);
      }
    } catch (error) {
      toast.error("Documento não encontrado!");
      setDoc("");
      setLoading(false);
    }
  };

  const handleButtonClick = (docId) => {
    navigate(`/login/${docId}`, { state: { doc: doc } });
  };

  function watchMask(value) {
    if (value.length <= 14) {
      setMask("999.999.999-999");
      setDoc(value);
    } else {
      setMask("99.999.999/9999-99");
      setDoc(value);
    }
  }

  return (
    <>
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              <div className="d-flex align-items-center">
                <img src={foto} width={250} alt="Logo IB3 Capital" />
              </div>
            </div>
            <div className="icon">
              <i className="fa fa-lock"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content fs-13px">
              {moreDocs && (
                <>
                  <p>Selecione a conta que deseja entrar:</p>
                  {allDocs &&
                    allDocs.map((doc, i) => (
                      <div key={i} className="row">
                        <div
                          key={doc.id}
                          style={{ cursor: "pointer" }}
                          className="card form-control mt-2"
                          onClick={() => handleButtonClick(doc.id)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="card-body pb-0 text-white">
                              <div>
                                <p>Nome: {doc.name}</p>
                              </div>
                              <div className="d-flex justify-content-between">
                                <p>Conta: {doc.environment}</p>
                              </div>
                            </div>
                            <div className="me-4" style={{fontSize: '20px'}}>
                              <i className="fa-solid fa-chevron-right"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              )}
              {firstDoc && (
                <>
                  <form onSubmit={onSubmit}>
                    <div className="form-floating mb-20px">
                      <ReactInputMask
                        required
                        mask={mask}
                        value={doc}
                        ref={inputRef}
                        type="username"
                        maskChar={null}
                        placeholder="Informe o seu Documento: "
                        className="form-control fs-13px h-45px"
                        onChange={(event) => watchMask(event.target.value)}
                      />
                      <label className="d-flex align-items-center py-0">
                        CPF / CNPJ
                      </label>
                    </div>
                    {showAlert && (
                      <div className="alert alert-danger fade show">
                        Sistema Inativo, contate o administrador.{" "}
                        <i className="fa-solid fa-circle-exclamation"></i>
                      </div>
                    )}

                    <div className="login-buttons">
                      <button
                        type="submit"
                        disabled={loading}
                        className="btn h-45px btn-blue d-flex align-items-center justify-content-center w-100 btn-lg"
                      >
                        {loading ? (
                          <ThreeDots
                            height="80"
                            width="80"
                            radius="9"
                            color="#fff"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            wrapperClassName=""
                            visible={true}
                          />
                        ) : (
                          <>Entrar</>
                        )}
                      </button>
                      <div className="text-center pt-2">
                        <b>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate("/createAccount")}
                            className="text-gray bg-transparent border-none"
                          >
                            Cadastre-se{" "}
                            <i className="fas fa-arrow-right ml-1"></i>
                          </div>
                        </b>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
